"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[8828,1408,9360,9240],{

/***/ 8294:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "$": function() { return /* binding */ CountryComponentWrapper; }
/* harmony export */ });
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);

var CountryComponentWrapper = function(param) {
    var countries = param.countries, children = param.children;
    if (countries.includes("hk")) {
        return children;
    }
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .Fragment */ .HY, {});
};


/***/ }),

/***/ 28928:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "h": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(48641);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(67294);
/* harmony import */ var design_system_components_Logo__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48534);
/* harmony import */ var src_colors__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(52269);
/* harmony import */ var src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(44873);
/* eslint-disable react/no-unused-prop-types */ /* eslint-disable react/destructuring-assignment */ 







var Template = function(props) {
    var ref, ref1;
    var children = react__WEBPACK_IMPORTED_MODULE_0__.Children.toArray(props.children).filter(react__WEBPACK_IMPORTED_MODULE_0__.isValidElement);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsxs */ .BX)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
        justifyContent: "center",
        position: "sticky",
        top: 0,
        zIndex: 11,
        bgColor: src_colors__WEBPACK_IMPORTED_MODULE_2__/* .colors.white.off */ .O.white.off,
        p: [
            4,
            null,
            6
        ],
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.15)",
        alignItems: "center"
    }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header")), {
        children: [
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Box */ .xu, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                width: "40px",
                as: "button",
                ml: [
                    0,
                    8
                ]
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-children-left")), {
                children: (ref = children.find(function(child) {
                    return child.type === Left;
                })) === null || ref === void 0 ? void 0 : ref.props.children
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                flex: "1",
                justifyContent: "center"
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-logo")), {
                children: /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(design_system_components_Logo__WEBPACK_IMPORTED_MODULE_1__/* .Logo */ .T, {
                    isClickable: props === null || props === void 0 ? void 0 : props.isClickable,
                    customClick: props.customLogoClick,
                    rediectToWebFlow: props.redirectToWebFlowWhenNotAuth
                })
            })),
            /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_4__/* .Flex */ .kC, (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                width: "40px",
                justifyContent: "flex-end",
                mr: [
                    0,
                    8
                ]
            }, (0,src_utils_getNameProp__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)("template-header-children-right")), {
                children: (ref1 = children.find(function(child) {
                    return child.type === Right;
                })) === null || ref1 === void 0 ? void 0 : ref1.props.children
            }))
        ]
    }));
};
var Left = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: children
    });
};
var Right = function(param) {
    var children = param.children;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_3__/* .Fragment */ .HY, {
        children: children
    });
};
var Header = Object.assign(Template, {
    Left: Left,
    Right: Right
});


/***/ }),

/***/ 86161:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "h": function() { return /* reexport */ PriceSelection; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_async_to_generator.mjs
var _async_to_generator = __webpack_require__(47568);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/next/dist/compiled/regenerator-runtime/runtime.js
var runtime = __webpack_require__(34051);
var runtime_default = /*#__PURE__*/__webpack_require__.n(runtime);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/lodash/lodash.js
var lodash = __webpack_require__(96486);
var lodash_default = /*#__PURE__*/__webpack_require__.n(lodash);
// EXTERNAL MODULE: ./node_modules/lodash/fp.js
var fp = __webpack_require__(78230);
// EXTERNAL MODULE: ./node_modules/next-i18next/dist/esm/index.js + 40 modules
var esm = __webpack_require__(76395);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/react-hook-form/dist/index.esm.mjs
var dist_index_esm = __webpack_require__(87536);
// EXTERNAL MODULE: ./node_modules/react-query/es/index.js
var es = __webpack_require__(88767);
// EXTERNAL MODULE: ./node_modules/yup/es/index.js + 204 modules
var yup_es = __webpack_require__(82954);
// EXTERNAL MODULE: ./components/Spacer/index.tsx
var Spacer = __webpack_require__(89246);
// EXTERNAL MODULE: ./design_system/components/OFButton/index.ts + 3 modules
var OFButton = __webpack_require__(63773);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./graphql/react-query/index.ts
var react_query = __webpack_require__(41562);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./src/configs/productVariants.ts
var productVariants = {
    prod_JzPlmDSdAjd2p6: [
        "quantity",
        "frequency"
    ],
    prod_JzgitGwlJPWAtV: [
        "quantity",
        "frequency"
    ],
    prod_KWPnD566MBSF3V: [
        "quantity",
        "frequency"
    ],
    prod_KWPbd5ELZXLu1c: [
        "quantity",
        "frequency"
    ]
};

// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
// EXTERNAL MODULE: ./src/hooks/useYup.ts
var useYup = __webpack_require__(47358);
// EXTERNAL MODULE: ./src/utils/getNameProp.ts
var getNameProp = __webpack_require__(44873);
// EXTERNAL MODULE: ./src/utils/priceFormat.ts + 1 modules
var priceFormat = __webpack_require__(69240);
// EXTERNAL MODULE: ./src/wrappers/TrackingWrapper.tsx
var TrackingWrapper = __webpack_require__(11548);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var media_query_dist_index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/accordion/dist/index.esm.js
var accordion_dist_index_esm = __webpack_require__(31937);
// EXTERNAL MODULE: ./src/hooks/index.ts + 13 modules
var hooks = __webpack_require__(18467);
;// CONCATENATED MODULE: ./components/PriceSelection/FAQSection.tsx




var FAQSection = function(param) {
    var t = param.t, type = param.type;
    var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    var addSuffixCountry = (0,hooks/* useConfig */.ZR)().addSuffixCountry;
    var faTransKey = addSuffixCountry("price_selection");
    var faqs = [
        0,
        1,
        2
    ];
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        direction: "column",
        mb: isMobile ? "200px" : 0,
        mt: "30px",
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                fontWeight: "bold",
                fontSize: "2xl",
                py: 4,
                textAlign: "center",
                borderTop: "1px solid",
                borderTopColor: "primaryTwo.500",
                children: t("price_selection:frequently-asked-title")
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(accordion_dist_index_esm/* Accordion */.UQ, {
                allowToggle: true,
                children: faqs.map(function(index) {
                    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(accordion_dist_index_esm/* AccordionItem */.Qd, {
                        borderTopColor: "primaryTwo.500",
                        borderBottomColor: "primaryTwo.500",
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(accordion_dist_index_esm/* AccordionButton */.KF, {
                                p: "20px 0px",
                                children: [
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, {
                                        flex: "1",
                                        textAlign: "left",
                                        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Text */.xv, {
                                            fontWeight: "bold",
                                            children: t("".concat(faTransKey, ":FAQ-").concat(type, ".").concat(index, ".question"))
                                        })
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(accordion_dist_index_esm/* AccordionIcon */.XE, {
                                        fontSize: "lg",
                                        boxSize: 6
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(accordion_dist_index_esm/* AccordionPanel */.Hk, {
                                pb: 4,
                                pl: 0,
                                children: t("".concat(faTransKey, ":FAQ-").concat(type, ".").concat(index, ".answer"))
                            })
                        ]
                    }, index);
                })
            })
        ]
    });
};
/* harmony default export */ var PriceSelection_FAQSection = (/*#__PURE__*/(0,react.memo)(FAQSection));

// EXTERNAL MODULE: ./components/Common/CountryComponentWrapper.tsx
var CountryComponentWrapper = __webpack_require__(8294);
// EXTERNAL MODULE: ./design_system/components/Badge/index.ts + 5 modules
var Badge = __webpack_require__(1408);
// EXTERNAL MODULE: ./src/utils.ts
var utils = __webpack_require__(49384);
// EXTERNAL MODULE: ./src/utils/checkCountry.ts
var checkCountry = __webpack_require__(42304);
// EXTERNAL MODULE: ./components/PriceSelection/utils/index.ts + 1 modules
var PriceSelection_utils = __webpack_require__(39135);
;// CONCATENATED MODULE: ./components/PriceSelection/Variation.tsx












var Variation = function(param) {
    var variant = param.variant, price = param.price, isChecked = param.isChecked, product = param.product, basePricePerBox = param.basePricePerBox, setValue = param.setValue;
    var ref, ref1;
    var isMobile = (0,media_query_dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    var t = (0,esm/* useTranslation */.$G)([
        "price_selection",
        "shop"
    ]).t;
    var unit = product === null || product === void 0 ? void 0 : (ref = product.texts) === null || ref === void 0 ? void 0 : ref.unit_patient;
    var isPopular = price.metadata["".concat(variant, "_popular")] || false;
    var display = price.metadata["".concat(variant, "_display")] || "";
    var splitedDisplay = (0,PriceSelection_utils/* getDisplayVariationText */.L$)(variant, display);
    var variantActualPriceDisplay = price.metadata["".concat(variant, "_actual_price_display")] || "";
    var totalPriceDisplay = price.metadata.actual_price_display || "";
    var displayPricePerDose = (0,utils/* addCurrencyPrefix */.US)(variantActualPriceDisplay);
    var savePercent = variant === "frequency" ? (0,PriceSelection_utils/* calculateBundleSavePercent */.Us)(basePricePerBox, price) : null;
    var strikeoutPrice = variant === "frequency" ? (0,PriceSelection_utils/* calculateStrikeoutPrice */.ec)(basePricePerBox, price) : null;
    var isBasePrice = strikeoutPrice === (0,utils/* extractNumberFromText */.Sx)(totalPriceDisplay);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
        onClick: function() {
            setValue("variant_selection", price.id, {
                shouldValidate: true
            });
        },
        direction: "column",
        justify: "flex-start",
        align: "flex-start",
        w: "100%",
        position: "relative",
        mx: "auto",
        cursor: "pointer",
        bg: "white",
        px: 6,
        py: 4,
        borderRadius: "md",
        boxShadow: "md",
        borderWidth: "2px",
        borderColor: isChecked ? colors/* colors.orange.400 */.O.orange[400] : "none",
        mb: [
            "16px",
            "21px"
        ],
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                w: "100%",
                gap: "1rem",
                justify: "space-between",
                align: "center",
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                        textStyle: "h6",
                        children: variant === "frequency" ? splitedDisplay === null || splitedDisplay === void 0 ? void 0 : (ref1 = splitedDisplay[0]) === null || ref1 === void 0 ? void 0 : ref1.toLocaleLowerCase() : splitedDisplay === null || splitedDisplay === void 0 ? void 0 : splitedDisplay[0]
                    }),
                    isPopular && isPopular === "true" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* MostPopularBadge */.U, {
                        textTransform: "uppercase",
                        size: isMobile ? "small" : "large",
                        children: t("price_selection:labels.most_popular")
                    })
                ]
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                textStyle: "body3",
                mt: 2,
                children: (splitedDisplay === null || splitedDisplay === void 0 ? void 0 : splitedDisplay[1]) || ""
            }),
            variant === "frequency" && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {
                children: [
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        justifyContent: "flex-start",
                        mt: 2,
                        children: [
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                textStyle: "h6",
                                children: (0,priceFormat/* formatDisplayPriceByRegion */.q)(displayPricePerDose)
                            }),
                            unit && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OFText/* OFText */.o, {
                                textStyle: "table2",
                                children: [
                                    "\xa0/",
                                    (0,utils/* toTitleCase */.LF)(unit)
                                ]
                            }),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(CountryComponentWrapper/* CountryComponentWrapper */.$, {
                                countries: [
                                    generated.RegionType.Sg,
                                    generated.RegionType.Jp
                                ],
                                children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                    textStyle: "table2",
                                    pl: 2,
                                    children: (0,checkCountry/* checkCountry */.d)([
                                        generated.RegionType.Sg
                                    ]) ? t("shop:with-gst") : t("shop:with-vat")
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {
                        h: [
                            12,
                            10
                        ]
                    }),
                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                        w: "100%",
                        justify: "space-between",
                        align: "flex-end",
                        children: [
                            savePercent ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Badge/* OFBadge */.Rg, {
                                children: t("price_selection:labels.save", {
                                    percent: savePercent,
                                    defaultValue: ""
                                })
                            }) : // keep space-between
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, {}),
                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, {
                                children: [
                                    !isBasePrice && strikeoutPrice && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(OFText/* OFText */.o, {
                                        textStyle: "h6",
                                        color: colors/* colors.grey.600 */.O.grey[600],
                                        textDecoration: "line-through",
                                        align: "right",
                                        children: [
                                            (0,utils/* getCurrencyIcon */.Dp)(),
                                            (0,priceFormat/* formatDisplayPriceByRegion */.q)(strikeoutPrice === null || strikeoutPrice === void 0 ? void 0 : strikeoutPrice.toString())
                                        ]
                                    }),
                                    /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, {
                                        justify: "flex-start",
                                        gap: 2,
                                        children: [
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                                textStyle: "table2",
                                                textTransform: "uppercase",
                                                children: t("price_selection:labels.total-label")
                                            }),
                                            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                                                textStyle: "h5",
                                                children: totalPriceDisplay
                                            })
                                        ]
                                    })
                                ]
                            })
                        ]
                    })
                ]
            })
        ]
    });
};

;// CONCATENATED MODULE: ./components/PriceSelection/PriceSelection.tsx






























var defaultVariants = [
    "dosage",
    "frequency"
];
var query = "\nquery getStripeProductDetail($input: StripeProductFilterV2) {\n  viewer {\n    user {\n      stripeProducts(input: $input) {\n        id\n        texts {\n          benefits\n          unit_patient\n        }\n        metadata\n        prices {\n          id\n          active\n          type\n          unit_amount\n          unit_amount_decimal\n          metadata {\n            isArchived\n            frequency\n            dosage\n            boxes\n            frequency_quantity_display\n          }\n          texts {\n            actual_price_display\n            frequency\n            frequency_popular\n            frequency_display\n            frequency_actual_price_display\n            dosage\n            dosage_popular\n            dosage_display\n          }\n        }\n      }\n    }\n  }\n}\n\n";
var PriceSelection = function(param) {
    var _loop = function(i) {
        if (selectedValues[variants[i]]) {
            filteredPricesIds = filteredPricesIds.filter(function(price) {
                return price.metadata[variants[i]] === selectedValues[variants[i]];
            });
        }
    };
    var productId = param.productId, _onlyShowOTC = param.onlyShowOTC, onlyShowOTC = _onlyShowOTC === void 0 ? false : _onlyShowOTC, emitSelectedPriceId = param.emitSelectedPriceId, _autoProcess = param.autoProcess, autoProcess = _autoProcess === void 0 ? true : _autoProcess, onConfirm = param.onConfirm, isLoading = param.isLoading, preselect = param.preselect, _displayPrice = param.displayPrice, displayPrice = _displayPrice === void 0 ? false : _displayPrice, _isShowFAQ = param.isShowFAQ, isShowFAQ = _isShowFAQ === void 0 ? true : _isShowFAQ, _confirmBtnText = param.confirmBtnText, confirmBtnText = _confirmBtnText === void 0 ? "" : _confirmBtnText, selectedVariant = param.selectedVariant, dosageAnswer = param.dosageAnswer;
    var ref;
    var t = (0,esm/* useTranslation */.$G)([
        "price_selection",
        "evaluation_intro"
    ]).t;
    var ref1 = (0,es.useQuery)([
        "getStripeProductDetail",
        productId
    ], (0,_async_to_generator/* default */.Z)(runtime_default().mark(function _callee() {
        var ref, ref1, viewer;
        return runtime_default().wrap(function _callee$(_ctx) {
            while(1)switch(_ctx.prev = _ctx.next){
                case 0:
                    ;
                    _ctx.next = 3;
                    return react_query/* default.request */.Z.request(query, {
                        input: {
                            id: productId
                        }
                    });
                case 3:
                    viewer = _ctx.sent.viewer;
                    return _ctx.abrupt("return", viewer === null || viewer === void 0 ? void 0 : (ref = viewer.user) === null || ref === void 0 ? void 0 : (ref1 = ref.stripeProducts) === null || ref1 === void 0 ? void 0 : ref1[0]);
                case 5:
                case "end":
                    return _ctx.stop();
            }
        }, _callee);
    })), {
    }), stripeProduct = ref1.data, isLoadingProduct = ref1.isLoading;
    var isAllPricesOTC = (0,react.useMemo)(function() {
        return stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.prices.every(function(price) {
            return price.type === generated.StripePriceType.OneTime;
        });
    }, [
        stripeProduct
    ]);
    var ref2 = (0,react.useState)(0), variantIndex = ref2[0], setVariantIndex = ref2[1];
    var ref3 = (0,react.useState)({}), selectedValues = ref3[0], setSelectedValues = ref3[1];
    var ref4 = (0,react.useState)(""), paymentAmount = ref4[0], setPaymentAmount = ref4[1];
    var ref5 = (0,react.useState)(null), defaultVal = ref5[0], setDefaultVal = ref5[1];
    var variants = productVariants[productId] || defaultVariants;
    var variant = selectedVariant || variants[variantIndex];
    var filteredPriceType = (0,react.useMemo)(function() {
        return onlyShowOTC || isAllPricesOTC ? generated.StripePriceType.OneTime : generated.StripePriceType.Recurring;
    }, [
        onlyShowOTC,
        isAllPricesOTC
    ]);
    var isLastVariant = variantIndex === variants.length - 1;
    var requiredPrescription = stripeProduct === null || stripeProduct === void 0 ? void 0 : (ref = stripeProduct.metadata) === null || ref === void 0 ? void 0 : ref.requires_prescription;
    var preselectPrice = null;
    if (preselect) {
        preselectPrice = stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.prices.find(function(price) {
            return price.id === preselect;
        });
        if (preselectPrice) {
            preselectPrice = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, preselectPrice), {
                metadata: (0,_object_spread/* default */.Z)({}, preselectPrice.metadata, preselectPrice.texts)
            });
        }
    }
    var filteredPricesIds = (0,react.useMemo)(function() {
        return stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.prices.reduce(function(prev, cur) {
            var ref;
            if (cur.type !== filteredPriceType || !cur.active || ((ref = cur.metadata) === null || ref === void 0 ? void 0 : ref.isArchived) === "true") {
                return prev;
            }
            var isMatchPreselecPriceMeta = selectedVariant ? (0,PriceSelection_utils/* checkPriceMetaMatchPreSelectMeta */.kJ)(cur, preselectPrice, selectedVariant) : null;
            if (isMatchPreselecPriceMeta !== null && !isMatchPreselecPriceMeta) {
                return prev;
            }
            return (0,_to_consumable_array/* default */.Z)(prev).concat([
                (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, cur), {
                    metadata: (0,_object_spread/* default */.Z)({}, cur.texts, cur.metadata)
                })
            ]);
        }, []);
    }, [
        filteredPriceType,
        preselectPrice,
        stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.prices,
        selectedVariant
    ]);
    for(var i = 0; i < variantIndex; i++)_loop(i);
    filteredPricesIds = lodash_default().orderBy(filteredPricesIds, function(item) {
        return +lodash_default().get(item, "metadata.".concat(variant));
    }, [
        "desc"
    ]);
    var uniquePricesByVariants = lodash_default().uniqBy(filteredPricesIds.filter(function(d) {
        return !!d.metadata[variant];
    }), "metadata.".concat(variant));
    var basePricePerBox = variant === "frequency" ? (0,PriceSelection_utils/* getBasePricePerBoxFromVariants */.Kg)(uniquePricesByVariants) : null;
    var validationSchema = yup_es/* object */.Ry({
        variant_selection: yup_es/* string */.Z_().required("At least one product is required")
    });
    var isFixedMonthlyDosage = (0,react.useMemo)(function() {
        return (0,PriceSelection_utils/* checkIsFixedVariant */.kW)(stripeProduct === null || stripeProduct === void 0 ? void 0 : stripeProduct.prices, "dosage");
    }, [
        stripeProduct
    ]);
    var btnText = (0,react.useMemo)(function() {
        return confirmBtnText || displayPrice && !(0,fp.isNil)(paymentAmount) && isLastVariant ? t("price_selection:confirm-price-message", {
            amount: paymentAmount
        }) : t("price_selection:confirm-button-text");
    }, [
        confirmBtnText,
        displayPrice,
        paymentAmount,
        t,
        isLastVariant
    ]);
    var heading = (0,react.useMemo)(function() {
        var type = "default";
        var options = {
            defaultValue: "",
            numOfMonths: 0,
            numOfTimes: 0,
            numOfTabs: 0
        };
        if (variant === "frequency") {
            if (!isFixedMonthlyDosage) {
                var ref;
                var mostPopularPrice = uniquePricesByVariants.find(function(currentPrice) {
                    return currentPrice.metadata.frequency_popular === "true";
                });
                var mostPopularFreq = ((mostPopularPrice === null || mostPopularPrice === void 0 ? void 0 : (ref = mostPopularPrice.metadata) === null || ref === void 0 ? void 0 : ref.frequency) || 3).toString();
                type = "based_on_dose";
                options.numOfMonths = parseInt(mostPopularFreq, 10);
            }
        } else if (variant === "dosage") {
            if (dosageAnswer) {
                type = "based_on_eval";
                options.numOfTimes = dosageAnswer;
                options.numOfTabs = dosageAnswer;
            }
        }
        return t("price_selection:headings.".concat(variant, ".").concat(type), options);
    }, [
        t,
        uniquePricesByVariants,
        variant,
        isFixedMonthlyDosage,
        dosageAnswer
    ]);
    var chooseYourText = (0,react.useMemo)(function() {
        if (variant === "frequency" && isFixedMonthlyDosage) {
            return "";
        }
        return t("price_selection:choose_your.".concat(variant), {
            defaultValue: ""
        });
    }, [
        variant,
        isFixedMonthlyDosage,
        t
    ]);
    var resolver = (0,useYup/* useYupValidationResolver */.X)(validationSchema);
    var ref6 = (0,dist_index_esm/* useForm */.cI)({
        resolver: resolver,
        mode: "onChange",
        defaultValues: {
            variant_selection: defaultVal
        }
    }), handleSubmit = ref6.handleSubmit, setValue = ref6.setValue, watch = ref6.watch;
    var price = watch("variant_selection", defaultVal);
    /*
   * Functions
   */ var onNextVariant = function(values) {
        // has selectedVariant -> treatment summary -> don't need to go next step
        if (selectedVariant && onConfirm) {
            onConfirm(values.variant_selection);
            return;
        }
        setSelectedValues((0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, selectedValues), (0,_define_property/* default */.Z)({}, variant, filteredPricesIds.find(function(p) {
            return p.id === values.variant_selection;
        }).metadata[variant])));
        if (!isLastVariant) {
            setVariantIndex(function(d) {
                return d + 1;
            });
        } else {
            if (emitSelectedPriceId) emitSelectedPriceId(values.variant_selection);
            if (onConfirm) onConfirm(values.variant_selection);
        }
    };
    var renderFAQSection = function() {
        return isLastVariant ? filteredPriceType === generated.StripePriceType.Recurring ? Countries/* CURRENT_COUNTRY */.Ho === generated.RegionType.Jp ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceSelection_FAQSection, {
            t: t,
            type: "shipping"
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(PriceSelection_FAQSection, {
            t: t,
            type: "frequency"
        }) : null : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(emotion_react_jsx_runtime_browser_esm/* Fragment */.HY, {});
    };
    (0,react.useEffect)(function() {
        var ref;
        var amount = (ref = filteredPricesIds === null || filteredPricesIds === void 0 ? void 0 : filteredPricesIds.find(function(p) {
            return p.id === price;
        })) === null || ref === void 0 ? void 0 : ref.unit_amount;
        setPaymentAmount((0,fp.isNil)(amount) ? null : (0,priceFormat/* formatPrice */.T)(amount));
    }, [
        price,
        filteredPricesIds,
        t
    ]);
    (0,react.useEffect)(function() {
        var ref, ref1;
        if (isLoadingProduct) {
            return;
        }
        // if unique prices filtered by variants are empty or less than or equal to 1, skip the dosage and display price selection as users do not need to choose dosage
        if (uniquePricesByVariants.length <= 1) {
            setVariantIndex(1);
        }
        var tempDefaultVal = !preselectPrice ? (ref = uniquePricesByVariants.find(function(p) {
            return p.metadata["".concat(variant, "_popular")] === "true";
        })) === null || ref === void 0 ? void 0 : ref.id : (ref1 = filteredPricesIds.find(function(currentPrice) {
            return currentPrice.id === preselectPrice.id;
        })) === null || ref1 === void 0 ? void 0 : ref1.id;
        setDefaultVal(tempDefaultVal);
    }, [
        uniquePricesByVariants,
        filteredPricesIds,
        preselectPrice,
        variant,
        isLoadingProduct
    ]);
    (0,react.useEffect)(function() {
        setValue("variant_selection", defaultVal, {
            shouldValidate: true
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [
        defaultVal
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(TrackingWrapper/* default */.ZP, {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,getNameProp/* default */.Z)("price-selection-container")), {
            maxWidth: "800px",
            w: "100%",
            children: [
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                    textStyle: "subhead1",
                    color: colors/* colors.orange.400 */.O.orange[400],
                    textTransform: "uppercase",
                    mb: 6,
                    children: t("price_selection:variant_heading.".concat(variant), {
                        defaultValue: ""
                    })
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    textStyle: "h4"
                }, (0,getNameProp/* default */.Z)("price-selection-title")), {
                    whiteSpace: "pre-line",
                    children: heading
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer/* default */.Z, {
                    y: "12"
                }),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                    textStyle: "body3",
                    mb: 4
                }, (0,getNameProp/* default */.Z)("price-selection-body")), {
                    children: chooseYourText
                })),
                /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("form", {
                    onSubmit: handleSubmit(onNextVariant),
                    children: [
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Box */.xu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, (0,getNameProp/* default */.Z)("price-selection-variation-form")), {
                            children: uniquePricesByVariants.map(function(currentPrice) {
                                return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Variation, {
                                    variant: variant,
                                    price: currentPrice,
                                    isChecked: watch("variant_selection") === currentPrice.id,
                                    setValue: setValue,
                                    product: stripeProduct,
                                    basePricePerBox: basePricePerBox
                                }, currentPrice.id);
                            })
                        })),
                        /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(Spacer/* default */.Z, {
                            y: "12"
                        }),
                        !autoProcess && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFButton/* FixedButtonsWrapper */.MK, {
                            children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFButton/* OFButton */.Vu, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
                                type: "submit",
                                disabled: !price,
                                isLoading: isLoading,
                                w: [
                                    "100%",
                                    null,
                                    "max-content"
                                ]
                            }, (0,getNameProp/* default */.Z)("price-selection-form-button")), {
                                children: btnText
                            }))
                        })
                    ]
                }),
                requiredPrescription && isShowFAQ && renderFAQSection()
            ]
        }))
    });
};

;// CONCATENATED MODULE: ./components/PriceSelection/index.ts



/***/ }),

/***/ 89246:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(35944);
/* harmony import */ var _chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(48641);


var Spacer = function(param) {
    var x = param.x, y = param.y;
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__/* .jsx */ .tZ)(_chakra_ui_react__WEBPACK_IMPORTED_MODULE_1__/* .Box */ .xu, {
        display: "block",
        mr: x,
        mt: y
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (Spacer);


/***/ }),

/***/ 1408:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "gF": function() { return /* reexport */ BADGE_STATUSES; },
  "wn": function() { return /* reexport */ ExternalStatus; },
  "U": function() { return /* reexport */ MostPopularBadge; },
  "Rg": function() { return /* reexport */ Badge; },
  "OE": function() { return /* reexport */ StatusBadge; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./design_system/components/OFText/index.ts
var OFText = __webpack_require__(92757);
// EXTERNAL MODULE: ./src/colors.ts
var colors = __webpack_require__(52269);
;// CONCATENATED MODULE: ./design_system/components/Badge/badge.constant.ts



var borderStyle = {
    borderWidth: 1,
    borderStyle: "solid"
};
var BADGE_THEME = {
    filledBlue: {
        bg: colors/* colors.blue.500 */.O.blue[500],
        color: colors/* colors.white.off */.O.white.off
    },
    outlinedBlue: (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        bg: "transparent",
        color: colors/* colors.blue.500 */.O.blue[500]
    }, borderStyle), {
        borderColor: colors/* colors.blue.500 */.O.blue[500]
    })
};

;// CONCATENATED MODULE: ./design_system/components/Badge/Badge.tsx
/* eslint-disable react/destructuring-assignment */ 






var SIZES = {
    large: {
        h: "36px"
    },
    small: {
        h: "24px"
    }
};
var OFBadge = function(_param) {
    var _variant = _param.variant, variant = _variant === void 0 ? "filledBlue" : _variant, _size = _param.size, size = _size === void 0 ? "large" : _size, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "variant",
        "size",
        "children"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "20px",
        w: "max-content",
        px: "12px",
        whiteSpace: "nowrap"
    }, SIZES[size], BADGE_THEME[variant], props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
            flex: 1,
            color: "inherit",
            textAlign: "center",
            textStyle: size === "large" ? "subhead1" : "labels",
            children: children
        })
    }));
};
/* harmony default export */ var Badge = (OFBadge);

// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var dist_index_esm = __webpack_require__(51469);
;// CONCATENATED MODULE: ./design_system/icons/ThumbUpIcon.tsx




var SvgThumbUpIcon = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        width: 40,
        height: 40,
        fill: "none",
        xmlns: "http://www.w3.org/2000/svg",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        style: {
            WebkitTransform: "scale(".concat(size / 40, ")")
        }
    }, props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M24.647 8.532c-.277-1.8-1.593-3.7-3.888-3.52l-.012.001a3.98 3.98 0 0 0-2.316 1.023 4.136 4.136 0 0 0-1.264 2.227l-.005.026c-.13.73-.313 1.449-.546 2.151a19.265 19.265 0 0 1-2.917 5.16 2.71 2.71 0 0 0-2.01-.893H7.748C6.224 14.707 5 15.969 5 17.512v14.68C5 33.737 6.224 35 7.747 35h3.943c.84 0 1.589-.384 2.092-.988h11.764c1.25 0 2.306-.038 3.213-.379.975-.366 1.675-1.035 2.351-2.032l.003-.004a11.225 11.225 0 0 0 1.395-2.918l1.75-7.045c.262-1.006.36-2.451-.152-3.728a3.898 3.898 0 0 0-1.349-1.749c-.654-.468-1.476-.742-2.46-.795h-.002c-.13-.007-2.087-.01-2.158-.01-.455 0-.965.004-1.492.008-.733.005-1.5.01-2.205.006l.038-.813c.048-1.02.098-2.089.152-2.875l.025-.32c.069-.843.15-1.847-.008-2.826Zm-10.21 23.48h11.109c1.287 0 2-.055 2.532-.255.465-.174.874-.495 1.414-1.29a9.212 9.212 0 0 0 1.12-2.311l1.746-7.03c.194-.742.229-1.716-.072-2.465a1.906 1.906 0 0 0-.659-.868c-.302-.217-.752-.397-1.43-.434h-.035l-.278-.002a326.912 326.912 0 0 0-1.747-.004c-.427 0-.919.003-1.436.006-1.121.008-2.361.016-3.317-.007a.975.975 0 0 1-.7-.321 1.01 1.01 0 0 1-.259-.735c.028-.491.057-1.121.088-1.785.05-1.047.102-2.178.157-2.977v-.007c.01-.112.018-.222.026-.33v-.005c.07-.874.129-1.619.012-2.338l-.002-.01c-.187-1.225-.918-1.904-1.79-1.839-.436.041-.848.224-1.176.522a2.127 2.127 0 0 0-.648 1.135 17.5 17.5 0 0 1-.634 2.475 21.235 21.235 0 0 1-4.022 6.661v14.214Z",
            fill: color || "#595959"
        })
    }));
};
/* harmony default export */ var ThumbUpIcon = (SvgThumbUpIcon);

;// CONCATENATED MODULE: ./design_system/components/Badge/MostPopularBadge.tsx
/* eslint-disable react/destructuring-assignment */ 







var MostPopularBadge_SIZES = {
    large: {
        h: "36px",
        p: "18px 8px"
    },
    small: {
        h: "24px",
        p: "14px 4px"
    }
};
var MostPopularBadge = function(_param) {
    var _size = _param.size, size = _size === void 0 ? "small" : _size, iconProps = _param.iconProps, children = _param.children, props = (0,_object_without_properties/* default */.Z)(_param, [
        "size",
        "iconProps",
        "children"
    ]);
    var isMobile = (0,dist_index_esm/* useBreakpointValue */.Sx)({
        base: true,
        md: false
    });
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "center",
        bg: colors/* colors.orange.400 */.O.orange[400],
        w: "max-content",
        borderRadius: "20px"
    }, MostPopularBadge_SIZES[size], props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(ThumbUpIcon, (0,_object_spread/* default */.Z)({
                color: colors/* colors.white.off */.O.white.off,
                size: size === "large" ? 24 : 20
            }, iconProps)),
            !isMobile && /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
                flex: 1,
                color: colors/* colors.white.off */.O.white.off,
                textStyle: size === "large" ? "subhead1" : "labels",
                pr: "10px",
                children: children
            })
        ]
    }));
};

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/react-i18next/dist/es/index.js + 29 modules
var es = __webpack_require__(1922);
// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
;// CONCATENATED MODULE: ./design_system/components/Badge/StatusBadge.tsx
/* eslint-disable react/destructuring-assignment */ 









var ExternalStatus;
(function(ExternalStatus) {
    ExternalStatus["approved"] = "approved";
    ExternalStatus["completed"] = "completed";
    ExternalStatus["saved"] = "saved";
    ExternalStatus["rejected"] = "rejected";
    ExternalStatus[// plan page
    "outOfStock"] = "out_of_stock";
    ExternalStatus["oneTimePurchase"] = "one_time_purchase";
    ExternalStatus[// ops
    "pendingConfirmation"] = "pending_confirmation";
})(ExternalStatus || (ExternalStatus = {}));
var StatusBadge_SIZES = {
    large: {
        minW: "180px",
        h: "24px"
    },
    small: {
        minW: "124px",
        h: "24px"
    }
};
var _obj;
var BADGE_STATUSES = (_obj = {}, (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Active, {
    text: "Active",
    bg: colors/* colors.green.500 */.O.green[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Cancel, {
    text: "Cancelled",
    bg: colors/* colors.grey.800 */.O.grey[800],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.CancelBooking, {
    text: "Cancel Booking",
    bg: colors/* colors.green.400 */.O.green[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Cancelled, {
    text: "Cancelled",
    bg: colors/* colors.grey.800 */.O.grey[800],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Deleted, {
    text: "Deleted",
    bg: colors/* colors.red.400 */.O.red[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.OnHold, {
    text: "On hold",
    bg: colors/* colors.green.200 */.O.green[200]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Paused, {
    text: "Paused",
    bg: colors/* colors.green.200 */.O.green[200]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Pending, {
    text: "Pending",
    bg: colors/* colors.blue.400 */.O.blue[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingBooking, {
    text: "Pending Booking",
    bg: colors/* colors.blue.400 */.O.blue[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingDelivery, {
    text: "Pending Delivery",
    bg: colors/* colors.blue.500 */.O.blue[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Verified, {
    text: "Pending Delivery",
    bg: colors/* colors.blue.500 */.O.blue[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingProcessing, {
    text: "Pending Delivery",
    bg: colors/* colors.blue.500 */.O.blue[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingPayment, {
    text: "Pending Payment",
    bg: colors/* colors.red.400 */.O.red[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingPrescription, {
    text: "Pending RX",
    bg: colors/* colors.yellow.100 */.O.yellow[100]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingResults, {
    text: "Pending Results",
    bg: colors/* colors.purple.400 */.O.purple[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingSamples, {
    text: "Pending Samples",
    bg: colors/* colors.purple.100 */.O.purple[100]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PrescriptionChange, {
    text: "Rx Changed",
    bg: colors/* colors.yellow.400 */.O.yellow[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PrescriptionRejected, {
    text: "Rejected",
    bg: colors/* colors.grey.800 */.O.grey[800],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.Refunded, {
    text: "Refunded",
    bg: colors/* colors.yellow.400 */.O.yellow[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.ResultsReady, {
    text: "Results Ready",
    bg: colors/* colors.purple.400 */.O.purple[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.SamplesPickupScheduled, {
    text: "Samples Pick Up Scheduled",
    bg: colors/* colors.yellow.400 */.O.yellow[400]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingPrescriptionFu, {
    text: "Pending Follow Up",
    bg: colors/* colors.blue.200 */.O.blue[200]
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingBookingFu, {
    text: "Follow Up Due",
    bg: colors/* colors.blue.500 */.O.blue[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.approved, {
    text: "Approved",
    bg: colors/* colors.green.300 */.O.green[300]
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.completed, {
    text: "Completed",
    bg: colors/* colors.blue.300 */.O.blue[300]
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.rejected, {
    text: "Rejected",
    bg: colors/* colors.grey.800 */.O.grey[800],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.saved, {
    text: "Saved",
    bg: colors/* colors.yellow.200 */.O.yellow[200]
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.oneTimePurchase, {
    text: "One Time Purchase",
    bg: colors/* colors.green.300 */.O.green[300]
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.outOfStock, {
    text: "Out of Stock",
    bg: colors/* colors.grey.400 */.O.grey[400]
}), (0,_define_property/* default */.Z)(_obj, ExternalStatus.pendingConfirmation, {
    text: "Pending Confirmation",
    bg: colors/* colors.yellow.400 */.O.yellow[400]
}), (0,_define_property/* default */.Z)(_obj, generated.PaymentStatus.Paid, {
    text: "Paid",
    bg: colors/* colors.green.500 */.O.green[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PaymentStatus.Unpaid, {
    text: "UnPaid",
    bg: colors/* colors.orange.400 */.O.orange[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PaymentStatus.Fail, {
    text: "UnPaid",
    bg: colors/* colors.red.400 */.O.red[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.Approve, {
    text: "Approved",
    bg: colors/* colors.green.500 */.O.green[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.Prescribed, {
    text: "Prescribed",
    bg: colors/* colors.green.500 */.O.green[500],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.Reject, {
    text: "Rejected",
    bg: colors/* colors.grey.800 */.O.grey[800],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.RxChange, {
    text: "Rx Changed",
    bg: colors/* colors.purple.400 */.O.purple[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.NoShow, {
    text: "No Show",
    bg: colors/* colors.purple.400 */.O.purple[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.ChangeConsult, {
    text: "Change Consult",
    bg: colors/* colors.purple.400 */.O.purple[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.PrescriptionStatus.Cancel, {
    text: "Cancel",
    bg: colors/* colors.purple.400 */.O.purple[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingUploadIc, {
    text: "Pending Upload IC",
    bg: colors/* colors.purple.400 */.O.purple[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingCheckout, {
    text: "Pending Checkout",
    bg: colors/* colors.green.400 */.O.green[400],
    color: colors/* colors.white.off */.O.white.off
}), (0,_define_property/* default */.Z)(_obj, generated.OrderStatus.PendingHumansaCheck, {
    text: "Pending Humansa",
    bg: colors/* colors.green.400 */.O.green[400],
    color: colors/* colors.white.off */.O.white.off
}), _obj);
var StatusBadge = function(_param) {
    var status = _param.status, _size = _param.size, size = _size === void 0 ? "large" : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "status",
        "size"
    ]);
    var ref, ref1, ref2;
    var t = (0,es/* useTranslation */.$G)([
        "common"
    ]).t;
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(index_esm/* Flex */.kC, (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        alignItems: "center",
        justifyContent: "center",
        borderRadius: "12px",
        bg: (ref = BADGE_STATUSES[status]) === null || ref === void 0 ? void 0 : ref.bg
    }, StatusBadge_SIZES[size], props), {
        children: /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(OFText/* OFText */.o, {
            color: ((ref1 = BADGE_STATUSES[status]) === null || ref1 === void 0 ? void 0 : ref1.color) || colors/* colors.black.900 */.O.black[900],
            textStyle: "labels",
            textTransform: "uppercase",
            children: t("common:status_badge.".concat(status), {
                defaultValue: (ref2 = BADGE_STATUSES[status]) === null || ref2 === void 0 ? void 0 : ref2.text
            }).toLocaleUpperCase()
        })
    }));
};

;// CONCATENATED MODULE: ./design_system/components/Badge/index.ts






/***/ }),

/***/ 48534:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "T": function() { return /* reexport */ Logo_Logo; }
});

// EXTERNAL MODULE: ./node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.js
var emotion_react_jsx_runtime_browser_esm = __webpack_require__(35944);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/media-query/dist/index.esm.js
var index_esm = __webpack_require__(51469);
// EXTERNAL MODULE: ./node_modules/@chakra-ui/layout/dist/index.esm.js
var dist_index_esm = __webpack_require__(48641);
// EXTERNAL MODULE: ./node_modules/next-auth/react/index.js
var react = __webpack_require__(33299);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
var router_default = /*#__PURE__*/__webpack_require__.n(router);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_without_properties.mjs + 1 modules
var _object_without_properties = __webpack_require__(99534);
;// CONCATENATED MODULE: ./design_system/icons/LogoOfNoahZoey.tsx




var SvgLogoOfNoahZoey = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: 40,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 744.56 102.37",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        color: color
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21.98 81.64C4.85 77.04-3.48 61.55 1.37 43.47c4.85-18.05 19.79-27.34 36.95-22.73 17.13 4.6 25.46 20.09 20.61 38.17-4.85 18.08-19.79 27.34-36.95 22.73Zm15-55.98c-13.78-3.7-25.29 3.89-29.46 19.47-4.17 15.55 2.01 27.88 15.79 31.58 13.78 3.7 25.29-3.89 29.46-19.47 4.17-15.55-2.01-27.88-15.79-31.58ZM68.7 81.56V20.81h40.21v5.12H74.69v22.54h27.2v5.12h-27.2v27.96H68.7Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                style: {
                    fill: "none",
                    stroke: "#000",
                    strokeMiterlimit: 10
                },
                d: "M172.16 0v102.37"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "m530.16 17.11-2.81 23.46h.92c.19-1.76.49-3.51.89-5.24 4.18-16.57 22.14-16.62 22.14-16.62h10.77l.46-.78-37.96 63.33h59.78l-1.55-28.69h-.92c-1.24 7.08-3.27 13.28-6.69 18.03-7.71 9.34-19.82 9-19.82 9h-8.02l37.89-62.48h-55.07ZM613.66 32.51c-14.94 0-26.58 10.45-26.58 24.74s11.64 24.65 26.58 24.65 26.66-10.45 26.66-24.65-11.64-24.74-26.66-24.74Zm0 48.66c-7.97 0-7.97-13.2-7.97-23.92s0-24.01 7.97-24.01 8.06 13.56 8.06 24.01c0 10.72 0 23.92-8.06 23.92ZM694.28 62.47l-.55-.28c-3.21 5.32-8.16 8.8-15.39 8.8-11.91 0-16.95-9.44-16.95-19.05h30.88c-.02-8.56-4.6-18.45-20.53-19.43-14.92-.92-27.58 9.81-27.58 24.47s9.53 24.93 24.47 24.93c13.11 0 21.35-8.53 25.66-19.44Zm-24.01-29.23c7.33 0 8.34 11.11 7.89 17.78h-16.78c.09-6.42 2.38-17.78 8.89-17.78Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M729.49 33.98v.73c1.67.25 2.77.92 3.44 1.89.17.34 1.45 3.11.2 6.09l-9.22 19.66-7.43-16.46c-2.5-5.51-5.66-11.71 1.21-11.29v-.62h-28.75v.81c4.05.76 6.17 3.88 8.99 9.77l17.35 36.19-2.57 5.47c-2.44 5-5.74 10.3-10.67 13.19-2.39 1.4-5.38 1.61-8.03.87 3.33 0 6.38-1.88 7.86-4.86l.11-.25c2.04-4.4.13-9.61-4.27-11.65a8.768 8.768 0 0 0-11.65 4.27 8.7 8.7 0 0 0-.56 5.77c.78 4.51 4.68 8.8 11.58 8.8 10.1 0 15.87-11.75 19.32-19.22l14.23-30.32c5.32-11.29 8.6-17.38 13.93-18.14v-.71h-15.07ZM260.18 32.52c-4.01 0-8.74 2.89-10.5 5.49v-5.05H235.4v48.62h14.28V54.82c0-2.81.71-4.93 2.18-6.46 1.47-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.71 5.46 1.71 10.35v22.57h14.28V56.16c0-7.7-1.68-13.6-5.01-17.56-3.4-4.03-8.48-6.08-15.12-6.08ZM312.27 32.52c-6.98 0-13 2.44-17.88 7.26-4.88 4.82-7.37 10.79-7.37 17.71s2.49 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36s12.93-2.47 17.84-7.36c4.91-4.89 7.41-10.84 7.41-17.71s-2.48-12.88-7.37-17.71c-4.89-4.83-10.9-7.26-17.88-7.26Zm8.64 33.59c-2.48 2.48-5.3 3.69-8.64 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.67-5.3-3.67-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.64 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.21 6.13-3.69 8.61ZM379.42 37.33c-1.35-2.91-7.25-4.81-11.38-4.81-7.01 0-13.04 2.44-17.92 7.27-4.88 4.83-7.36 10.79-7.36 17.71s2.5 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36 0 0 7.57 0 11.39-5.37v4.37h14.28V32.95H379.4v4.38Zm-2.76 28.77c-2.48 2.48-5.31 3.69-8.63 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.68-5.3-3.68-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.63 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.2 6.13-3.68 8.61ZM442.13 38.6c-3.39-4.04-8.48-6.08-15.12-6.08-4.01 0-7.52.86-10.5 2.56V11.22h-14.28v70.35h14.28V54.81c0-2.81.71-4.93 2.19-6.46 1.48-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.72 5.46 1.72 10.35v22.57h14.28V56.15c0-7.69-1.68-13.6-5.01-17.56ZM493.88 52.94l4.87 5.92h-4.1l-2.88-3.49c-1.83 2.11-4.38 3.77-8.03 3.77-5.31 0-9.17-3.16-9.17-7.95s2.92-6.89 6.65-8.72c-1.7-2.19-2.55-4.18-2.55-6.12 0-4.38 3.45-6.65 7.1-6.65s6.33 2.47 6.33 5.96-2.51 5.92-6.21 7.5l6.08 7.42 3.53-6.69h3.12l-4.75 9.04Zm-3.85.28-7.22-8.8c-2.84 1.38-4.83 3.04-4.83 6.45s2.23 5.52 5.88 5.52c2.31 0 4.42-1.05 6.16-3.16Zm-5.6-11.92c3.25-1.46 4.5-2.92 4.5-5.72 0-1.87-1.34-3.24-3.29-3.24s-3.73 1.22-3.73 4.06c0 1.46.93 2.92 2.51 4.91ZM474.34 68.2h23.79v3h-23.79z"
            })
        ]
    }));
};
/* harmony default export */ var LogoOfNoahZoey = (SvgLogoOfNoahZoey);

;// CONCATENATED MODULE: ./design_system/icons/LogoOfNoah.tsx




var SvgLogoOfNoah = function(_param) {
    var color = _param.color, _size = _param.size, size = _size === void 0 ? 40 : _size, props = (0,_object_without_properties/* default */.Z)(_param, [
        "color",
        "size"
    ]);
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsxs */.BX)("svg", (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({
        height: 40,
        xmlns: "http://www.w3.org/2000/svg",
        viewBox: "0 0 447.13 102.37",
        id: "svg-wrapper",
        transform: "scale(".concat(size / 40, ")"),
        color: color
    }, props), {
        children: [
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                d: "M21.98 81.64C4.85 77.04-3.48 61.55 1.37 43.47c4.85-18.05 19.79-27.34 36.95-22.73 17.13 4.6 25.46 20.09 20.61 38.17-4.85 18.08-19.79 27.34-36.95 22.73Zm15-55.98c-13.78-3.7-25.29 3.89-29.46 19.47-4.17 15.55 2.01 27.88 15.79 31.58 13.78 3.7 25.29-3.89 29.46-19.47 4.17-15.55-2.01-27.88-15.79-31.58ZM68.7 81.56V20.81h40.21v5.12H74.69v22.54h27.2v5.12h-27.2v27.96H68.7ZM260.18 32.5c-4.01 0-8.74 2.89-10.5 5.49v-5.05H235.4v48.62h14.28V54.8c0-2.81.71-4.93 2.18-6.46 1.47-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.71 5.46 1.71 10.35v22.57h14.28V56.14c0-7.7-1.68-13.6-5.01-17.56-3.4-4.03-8.48-6.08-15.12-6.08ZM312.27 32.5c-6.98 0-13 2.44-17.88 7.26-4.88 4.82-7.37 10.79-7.37 17.71s2.49 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36s12.93-2.47 17.84-7.36c4.91-4.89 7.41-10.84 7.41-17.71s-2.48-12.88-7.37-17.71c-4.89-4.83-10.9-7.26-17.88-7.26Zm8.64 33.59c-2.48 2.48-5.3 3.69-8.64 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.67-5.3-3.67-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.64 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.21 6.13-3.69 8.61ZM379.42 37.31c-1.35-2.91-7.25-4.81-11.38-4.81-7.01 0-13.04 2.44-17.92 7.27-4.88 4.83-7.36 10.79-7.36 17.71s2.5 12.83 7.41 17.71c4.92 4.88 10.92 7.36 17.84 7.36 0 0 7.57 0 11.39-5.37v4.37h14.28V32.93H379.4v4.38Zm-2.76 28.77c-2.48 2.48-5.31 3.69-8.63 3.69s-6.16-1.21-8.64-3.69c-2.48-2.48-3.68-5.3-3.68-8.61s1.2-6.13 3.68-8.61c2.48-2.48 5.3-3.69 8.64-3.69s6.16 1.21 8.63 3.69c2.48 2.48 3.68 5.3 3.68 8.61s-1.2 6.13-3.68 8.61ZM442.13 38.58c-3.39-4.04-8.48-6.08-15.12-6.08-4.01 0-7.52.86-10.5 2.56V11.2h-14.28v70.35h14.28V54.79c0-2.81.71-4.93 2.19-6.46 1.48-1.53 3.43-2.25 6.03-2.25 3.33 0 5.43.83 6.41 2.55 1.14 1.99 1.72 5.46 1.72 10.35v22.57h14.28V56.13c0-7.69-1.68-13.6-5.01-17.56Z"
            }),
            /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)("path", {
                style: {
                    fill: "none",
                    stroke: "#000",
                    strokeMiterlimit: 10
                },
                d: "M172.16 0v102.37"
            })
        ]
    }));
};
/* harmony default export */ var LogoOfNoah = (SvgLogoOfNoah);

// EXTERNAL MODULE: ./src/config.ts
var config = __webpack_require__(86704);
// EXTERNAL MODULE: ./src/constants/Countries.ts
var Countries = __webpack_require__(73252);
// EXTERNAL MODULE: ./src/constants/url.constants.ts
var url_constants = __webpack_require__(97479);
;// CONCATENATED MODULE: ./design_system/components/Logo/Logo.tsx








var Logo = function(param) {
    var _isClickable = param.isClickable, isClickable = _isClickable === void 0 ? true : _isClickable, customClick = param.customClick, _rediectToWebFlow = param.rediectToWebFlow, rediectToWebFlow = _rediectToWebFlow === void 0 ? false : _rediectToWebFlow;
    var isMobile = (0,index_esm/* useBreakpointValue */.Sx)([
        true,
        null,
        false
    ], {
        ssr: false
    });
    var ref = (0,react.useSession)(), session = ref.data;
    var logoSize = isMobile ? 24 : 28;
    var handleClickLogo = function() {
        if (!isClickable) {
            return;
        }
        if (customClick) {
            customClick();
            return;
        }
        if (session === null || session === void 0 ? void 0 : session.user) {
            router_default().push(url_constants/* V2_URL */.a_);
        } else if (rediectToWebFlow) {
            router_default().push(config/* config.WEBFLOW_URLS */.vc.WEBFLOW_URLS[Countries/* CURRENT_COUNTRY */.Ho]);
        }
    };
    return /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(dist_index_esm/* Box */.xu, {
        id: "logo",
        onClick: handleClickLogo,
        cursor: "pointer",
        children: Countries/* HAS_ZOEY_COUNTRY */.TO ? /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoOfNoahZoey, {
            height: logoSize
        }) : /*#__PURE__*/ (0,emotion_react_jsx_runtime_browser_esm/* jsx */.tZ)(LogoOfNoah, {
            height: logoSize
        })
    });
};
/* harmony default export */ var Logo_Logo = (Logo);

;// CONCATENATED MODULE: ./design_system/components/Logo/index.ts




/***/ }),

/***/ 69240:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "q": function() { return /* binding */ formatDisplayPriceByRegion; },
  "T": function() { return /* binding */ formatPrice; }
});

// EXTERNAL MODULE: ./graphql/generated.ts
var generated = __webpack_require__(12705);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
;// CONCATENATED MODULE: ./src/constants/currency.ts


var _obj;
var CURRENCY_BY_COUNTRY = (_obj = {}, (0,_define_property/* default */.Z)(_obj, generated.RegionType.Sg, "$"), (0,_define_property/* default */.Z)(_obj, generated.RegionType.Hk, "HK$"), (0,_define_property/* default */.Z)(_obj, generated.RegionType.Jp, "\xa5"), _obj);

// EXTERNAL MODULE: ./src/utils/checkCountry.ts
var checkCountry = __webpack_require__(42304);
;// CONCATENATED MODULE: ./src/utils/priceFormat.ts



var formatDisplayPriceByRegion = function(value) {
    if ("hk" === generated.RegionType.Jp) {
        return value === null || value === void 0 ? void 0 : value.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    }
    return value;
};
var formatPrice = function(price) {
    var isShowCurrency = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true, fixed = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 2;
    var currency = isShowCurrency ? CURRENCY_BY_COUNTRY["hk"] : "";
    var newFixed = (0,checkCountry/* checkCountry */.d)([
        generated.RegionType.Jp
    ]) ? 0 : fixed;
    var divisor = (0,checkCountry/* checkCountry */.d)([
        generated.RegionType.Hk,
        generated.RegionType.Sg
    ]) ? 100 : 1;
    var dividedPrice = price >= 0 ? "".concat(currency).concat((price / divisor).toFixed(newFixed)) : "-".concat(currency).concat((price * -1 / divisor).toFixed(newFixed));
    return formatDisplayPriceByRegion(dividedPrice);
};


/***/ }),

/***/ 11548:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* unused harmony exports setUtm, TrackingDataWrapper */
/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(47568);
/* harmony import */ var _home_runner_work_frontend_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _home_runner_work_frontend_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_home_runner_work_frontend_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var _emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(35944);
/* harmony import */ var js_cookie__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(31955);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(11865);
/* harmony import */ var lodash_snakeCase__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(lodash_snakeCase__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(67294);
/* harmony import */ var recoil__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4480);
/* harmony import */ var src_utils_tracking__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(86229);
/* harmony import */ var _dataTracking__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(43988);
/* harmony import */ var _dataTracking_events__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(26346);
/* harmony import */ var _states__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(64443);











function TrackingWrapper(param) {
    var pageName = param.pageName, metadata = param.metadata, children = param.children;
    var patient = (0,recoil__WEBPACK_IMPORTED_MODULE_4__/* .useRecoilValue */ .sJ)(_states__WEBPACK_IMPORTED_MODULE_8__/* .patientState */ .ao);
    (0,react__WEBPACK_IMPORTED_MODULE_3__.useEffect)(function() {
        (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_9__/* ["default"] */ .Z)(_home_runner_work_frontend_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            return _home_runner_work_frontend_frontend_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.next = 2;
                        return (0,_dataTracking__WEBPACK_IMPORTED_MODULE_6__/* .track */ .j)((0,_dataTracking_events__WEBPACK_IMPORTED_MODULE_7__/* .getViewPageEventName */ .p$)(pageName), metadata !== null && metadata !== void 0 ? metadata : {
                            "Browser Platform": (0,src_utils_tracking__WEBPACK_IMPORTED_MODULE_5__/* .getBrowserPlatform */ .bh)()
                        }, patient);
                    case 2:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee);
        }))();
    }, [
        patient,
        pageName,
        metadata
    ]);
    return /*#__PURE__*/ (0,_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .jsx */ .tZ)(_emotion_react_jsx_runtime__WEBPACK_IMPORTED_MODULE_10__/* .Fragment */ .HY, {
        children: children
    });
}
/* harmony default export */ __webpack_exports__["ZP"] = (TrackingWrapper);
var setUtm = function() {
    // get from query string, if not exist, remove cookie
    // this cookie is used for
    // + next-auth which need this info for identify user
    // + checkout
    var utm = getUtm();
    Object.keys(utm).forEach(function(key) {
        if (utm[key]) {
            Cookies.set(snakeCase(key), utm[key], {
                expires: 1,
                path: "/"
            });
        } else {
            Cookies.remove(snakeCase(key));
        }
    });
};
var TrackingDataWrapper = function(param) {
    var children = param.children;
    useEffect(function() {
        setUtm();
    }, []);
    return /*#__PURE__*/ _jsx(_Fragment, {
        children: children
    });
};


/***/ })

}]);